module.exports = __webpack_public_path__ + "img/roomSvgImg.67bead38.svg";